import "./polyfills";

import * as Components from "./components";
import "./vendors";

//Components object
Object.keys(Components).forEach((key) => Components[key]());
